<template>
  <div>
    <el-popover ref="popover" width="250" trigger="click">
      <div class="organisation-switch">
        <div class="organisation-switch--current">
          <span class="name-avatar">{{
            organisation && organisation.name.charAt(0)
          }}</span>
          <h6>{{ organisation && organisation.name }}</h6>
          <p>{{ user && user.email }}</p>
        </div>
        <div class="organisation-switch--others" v-loading="loading">
          <template v-if="organisations.length">
            <p>Switch Organisation</p>
            <div
              v-for="org in organisations"
              :key="org.organisation.id"
              class="org"
              @click="switchOrganisation(org.organisation.id)"
            >
              <span class="name-avatar">{{
                org.organisation && org.organisation.name.charAt(0)
              }}</span>
              <p>{{ org.organisation && org.organisation.name }}</p>
            </div>
          </template>
          <div
            v-if="userCan('auth', 'organisation.create')"
            class="org add"
            @click="create"
          >
            <span class="name-avatar">
              <i class="ra-icon--plus" />
            </span>
            <p>Add Organisation</p>
          </div>
        </div>
        <div class="organisation-switch--logout" @click="logout">
          <i class="ra-icon--log-out"></i>
          <span>Logout</span>
        </div>
      </div>
      <div slot="reference" class="switch-trigger">
        <span class="name-avatar">{{
          organisation && organisation.name.charAt(0)
        }}</span>
        <h6>{{ organisation && organisation.name }}</h6>
        <i class="ra-icon--chevron-down" />
      </div>
    </el-popover>
    <organisation-add
      :show.sync="showOrganisationAdd"
      @added="switchOrganisation"
    />
  </div>
</template>

<script>
import switchMixin from "@/mixins/switch";

export default {
  name: "OrganisationSwitch",
  mixins: [switchMixin],
  components: {
    OrganisationAdd: () =>
      import("@/components/Organisation/OrganisationAdd.vue")
  },
  data() {
    return {
      showOrganisationAdd: false
    };
  },
  methods: {
    create() {
      this.showOrganisationAdd = true;
      this.$refs.popover.doClose();
    }
  }
};
</script>

<style lang="scss" scoped>
.name-avatar {
  border-radius: 50px;
  background: var(--ra-grey-tertiary);
  color: #fff;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    height: 28px;
    width: 28px;
    background: var(--ra-grey-tertiary);
    color: #fff;
    margin-right: 5px;
  }

  h6 {
    font-size: 1rem;
    font-weight: 500;
    color: var(--ra-grey-tertiary);
  }

  i {
    margin-left: 10px;
    font-size: 0.875rem;
  }
}

.switch-label {
  color: var(--ra-grey-secondary);
  font-size: 0.65rem;
  font-weight: 500;
  margin: 10px 5px;
}

.organisation-switch {
  padding: 10px;

  &--current {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      height: 36px;
      width: 36px;
      font-size: 1.125rem;
      margin-bottom: 5px;
    }

    h6 {
      font-size: 1.125rem;
    }

    p {
      opacity: 0.5;
    }
  }

  &--others {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #b4bbbb30;
    max-height: 220px;
    overflow-y: scroll;

    > p {
      color: var(--ra-grey-tertiary);
      font-weight: 500;
      font-size: 0.75rem;
      margin-bottom: 7px;
    }

    .org {
      display: flex;
      padding: 7px 0;
      align-items: center;
      cursor: pointer;

      span {
        height: 24px;
        width: 24px;
        font-size: 0.75rem;
        background: var(--ra-white-bg);
        color: var(--ra-grey-primary);
        margin-right: 7px;
      }

      p {
        font-weight: 500;
        font-size: 0.8rem;
      }

      &.add {
        span {
          background: #36afa420;
        }
        p {
          color: #36afa4;
          font-weight: 400;
        }

        i {
          font-size: 0.75rem;
          color: #36afa4;
        }
      }
    }
  }

  &--logout {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 0;
    font-weight: 500;
    font-size: 0.75rem;
    color: var(--ra-red-primary);
    margin-top: 10px;

    i {
      margin-right: 5px;
    }
  }
}
</style>
